import React from 'react'
import { Navigate, Route, Routes } from "react-router-dom"
import AnnouncementDetailScreen from "screens/App/CRM/Announcement/AnnouncementDetailScreen"
import AnnouncementListScreen from "screens/App/CRM/Announcement/AnnouncementListScreen"
import ChatScreen from "screens/App/CRM/Dashboard/components/customers/ChatScreen"

import CustomerDashboardScreen from "screens/App/CRM/Dashboard/CustomerDashboardScreen"
import ShipmentCreateScreen from "screens/App/CRM/ShipmentRequest/ShipmentCreateScreen"
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen"
import ShipmentEditScreen from "screens/App/CRM/ShipmentRequest/ShipmentEditScreen"
import ShipmentListScreen from "screens/App/CRM/ShipmentRequest/ShipmentListScreen"

export const CustomerSidebarRouter = () => {
    return (
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<CustomerDashboardScreen />} />
        <Route path="customer-shipment" element={<ShipmentListScreen />} />
        <Route path="shipment/create" element={<ShipmentCreateScreen />} />
        <Route path="shipment/:id/detail" element={<ShipmentDetailScreen />} />
        <Route path="shipment/:id/edit" element={<ShipmentEditScreen />} />
        <Route path="announcement/list" element={<AnnouncementListScreen />} />
        <Route
          path="announcement/:id/detail"
          element={<AnnouncementDetailScreen />}
        />
        <Route path="customer-chat" element={<ChatScreen />} />
      </Routes>
    );
}
